const statuses = [
  {value:"",label:"Semua Status"},
  {value:"1",label:"Draft"},
  {value:"2",label:"Disetujui Pusat"},
]

export default {
  statuses,
}